import { Head } from 'components/Head';
import Layout from 'components/Layout';
import { XYSWap } from 'components/swap';

const Swap = () => {

  return (
    <Layout>
      <Head />
      <XYSWap/>
    </Layout>
  );
};

export default Swap;